import { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { BRAND, WHATSAPP_NUMBER } from "@/config";
import { PRODUCTION_LOCATION } from "@/data";

const defaultSettings = {
  brand_name: BRAND.name,
  tagline: BRAND.tagline,
  location_text: BRAND.location,
  email: BRAND.email,
  whatsapp_number: WHATSAPP_NUMBER,
  about_heading: "Warisan rasa dari peternak lebah Jombang.",
  about_intro:
    "Samsi Madu lahir dari kecintaan pada alam dan tradisi beternak lebah. Kami menjembatani peternak lokal dengan meja makan keluarga Indonesia — memastikan setiap toples berisi madu murni yang jujur.",
  about_history: "",
  about_image:
    "https://images.unsplash.com/photo-1586779161268-51d3e65d20fb?crop=entropy&cs=srgb&fm=jpg&q=85",
  about_image_position: 50,
  production_name: PRODUCTION_LOCATION.name,
  production_address: PRODUCTION_LOCATION.address,
  production_maps_url: PRODUCTION_LOCATION.mapsUrl,
  logo_url: "",
  shopee_url: "",
  tokopedia_url: "",
  tiktok_shop_url: "",
  instagram_url: "",
  facebook_url: "",
  tiktok_url: "",
};

const SettingsContext = createContext({
  settings: defaultSettings,
  waLink: () => "#",
  isLoading: true,
});

export const SettingsProvider = ({ children }) => {
  const { data, isLoading } = useQuery({
    queryKey: ["settings"],
    queryFn: async () => (await api.get("/settings")).data,
    placeholderData: defaultSettings,
    retry: 1,
  });

  // Guard against non-object responses (e.g. the SPA's own HTML coming back
  // when REACT_APP_BACKEND_URL is misconfigured) so the site never breaks.
  const isValid = data && typeof data === "object" && !Array.isArray(data) && "whatsapp_number" in data;
  const settings = isValid ? data : defaultSettings;

  const waLink = (message) =>
    `https://wa.me/${settings.whatsapp_number}?text=${encodeURIComponent(
      message || `Halo ${settings.brand_name}, saya ingin bertanya tentang produk madu.`
    )}`;

  return (
    <SettingsContext.Provider value={{ settings, waLink, isLoading }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
